export default {
  enabled: 'Ativado',
  disabled: 'Desativado',
  autoRedirect: 'Redirecionar Automaticamente',
  isHistory: 'É um histórico',
  titlePlaceholder: 'Digite o título',
  urlPlaceholder: 'Digite a url de redirecionamento...',
  checklist: 'Questionário',
  status: 'Status',
  sortBy: 'Ordenar por',
  sortByFormat: '{{field}} de forma {{type}}',
  configHistory: 'Configurar link como histórico',
  moveUp: 'Mover para Cima',
  moveDown: 'Mover para Baixo',
  duplicate: 'Duplicar',
  remove: 'Remover',
  filterSelection: 'Seleção de filtros',
  sort: 'Ordenar',
  field: 'Campo',
  order: 'Ordem',
  filters: 'Filtros',
  requiredChecklist: 'Questionário*',
  clearSelection: 'Limpar seleção',
  confirm: 'Confirmar',
  addNewLink: 'Adicionar novo link',
  save: 'Salvar',
  sortOptions: {
    ID: 'Id',
    YEARLY_ID: 'Código',
    SCHEDULING: 'Data de agendamento',
    END_DATE: 'Data de conclusão da atividade',
    START_DATE: 'Data de início da atividade'
  },
  orderOptions: {
    ASC: 'Ascendente',
    DESC: 'Descendente'
  },
  validation: {
    fillAllNames: 'Por favor, preencha todos nomes',
    fillAllUrls: 'Por favor, preencha todas urls',
    fillChecklistForHistory: 'Por favor, preencha o questionário para o histórico',
    invalidUrls: 'Existem urls inválidas',
    multipleAutoRedirects: 'Não é permitido mais de um redirecionamento automático',
    confirmSaveWithoutCustomLink: 'Certeza que deseja salvar sem link customizado?'
  },
  customizeLinks: 'Customizar links'
}
